import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Container, Section, Row, Field, Alert, FieldSelect, ActionButtonWrapper, ActionButton, AssetsList, AssetItem, AssetItemIcon, AssetsItemName, ConfirmMessage, NoAssets } from './Assets.styles';
import T, { Translate } from '../i18n/i18n';
import MultiPlayerSelector from '../Forms/MultiPlayerSelector/MultiPlayerSelector';
import Keyboard from '../../services/keyboardShortcuts';
import { listAssets, addAsset, editAsset, removeAsset } from '../../services/assets';
import { assetsActions, rtcBufferActions } from '../../redux/actions';


export default ({tableId}) => {

    const [filterValue, setFilterValue] = useState('');
    const [showForm, setshowForm] = useState(false);
    const [formId, setFormId] = useState(null);
    const [formName, setFormName] = useState('');
    const [formTags, setFormTags] = useState('');
    const [formType, setFormType] = useState(0);
    const [formVisibility, setFormVisibility] = useState('');
    const [formVisibleTo, setFormVisibleTo] = useState([]);
    const [initialForm, setInitialForm] = useState({});
    const [canChangeContent, setCanChangeContent] = useState(true);
    const [assetsList, setAssetsList] = useState([]);
    const [isRemoving, setIsRemoving] = useState(false);
    
    const dispatch = useDispatch();
    
    const isOwner = useSelector(state => state.authState.isOwner);
    const userId = useSelector(state => state.authState.id);
    const assetUpdate = useSelector(state => state.assetsState.assetUpdate);
    
    useEffect(() => {
        (async () => {
            let req = await listAssets(tableId);
            if (req.status === 'ok') {
                setAssetsList(req.payload.listing);
            }
        })();
    },[tableId]);

    const updateFilterValue = (v) => {
        setFilterValue(v);
    }

    const handleAddNewAsset = () => {
        setshowForm(true);
    }

    const handleOpenAsset = (asset) => {
        if (!isOwner) {
            handleOpenContent(asset);
            return;
        }

        setFormId(asset.id);
        setFormName(asset.name);
        setFormTags(asset.tags);
        setFormType(asset.type);
        setFormVisibility(asset.visibility);
        setFormVisibleTo(asset.visibleTo || []);
        setshowForm(true);
        setCanChangeContent(true);
        setInitialForm({
            name: asset.name,
            type: asset.type,
            visibility: asset.visibility,
            visibleTo: asset.visibleTo,
        });
    }

    const handleCancelForm = useCallback(() => {
        setFormId(null);
        setFormName('');
        setFormTags('');
        setFormType(0);
        setFormVisibility('');
        setFormVisibleTo([]);
        setshowForm(false);
    }, []);

    const handleSubmitAsset = async (keep = false) => {
        let data = {
            name: formName,
            tags: formTags,
            type: formType,
            visibility: formVisibility,
            visibleTo: formVisibleTo
        };
        let newList = {payload: {assetId: null, listing: []}}
        let newId = null;

        if (!formId) {
            newList = await addAsset(tableId, data);
            newId = newList.payload.assetId || null
            setFormId(newId);
            setCanChangeContent(true);
        } else {
            newList = await editAsset(tableId, formId, data);
            setInitialForm(data);
            setCanChangeContent(true);
            if (!keep) {
                handleCancelForm();
            }
        }
        setAssetsList(newList.payload.listing || []);
        dispatch(rtcBufferActions.pushOutputBuffer({
            type: 'assetUpdate',
            data: JSON.stringify({...data, action: formId ? 'update' : 'create', id: formId || newId})
        }));
    }

    const handleAskToRemove = () => {
        setIsRemoving(true);
    }

    const handleCancelRemove = () => {
        setIsRemoving(false);
    }

    const handleOpenContent = (asset) => {
        if (!canChangeContent) {
            return;
        }
    
        dispatch(assetsActions.openWindow(asset ? asset : {
            id: formId,
            name: formName,
            tags: formTags,
            type: parseInt(formType),
            visibility: parseInt(formVisibility),
            visibleTo: formVisibleTo,
        }));
    }

    const handleRemoveAsset = async () => {
        let newList = await removeAsset(tableId, formId);
        setAssetsList(newList.payload.listing || []);
        setIsRemoving(false);
        handleCancelForm();

        dispatch(rtcBufferActions.pushOutputBuffer({
            type: 'assetUpdate',
            data: JSON.stringify({action: 'remove', id: newList.payload.listing})
        }));
    }

    const handleNameChange = (v) => {
        setFormName(v);
        setCanChangeContent(v === initialForm.name);
    }

    const handleChangeType = (v) => {
        setFormType(v);
        setCanChangeContent(String(v) === String(initialForm.type));
    }

    const handleChangeVisibility = (v) => {
        setFormVisibility(v);
        setCanChangeContent(String(v) === String(initialForm.visibility));
    }

    const handleChangeVisibleTo = (v) => {
        setFormVisibleTo(v);
        setCanChangeContent(v === initialForm.visibleTo);
    }


    useEffect(() => {
        let escapeKey = () => {
            handleCancelForm();
            return false;
        };

        Keyboard.register({key:'ESCAPE'}, escapeKey);
        
        return () => {
            Keyboard.unregister({key:'ESCAPE'}, escapeKey);
        }
    }, [handleCancelForm]);

    useEffect(() => {
        if (!assetUpdate) {
            return;
        };

        let asset;

        try {
            asset = JSON.parse(assetUpdate);
        } catch (e) {
            console.error(Object.assign(e,{component:'AssetS', id: 'parseAssetUpdate'}));
            return;
        }

        console.log('receving assetUpdate', asset);

        if (asset.action === 'create') {
            if (String(asset.visibility) === '1' || 
               (String(asset.visibility) === '2' && asset.visibleTo.indexOf(userId) >= 0)) {
                
                setAssetsList(s => [...s, {
                    id: asset.id,
                    name: asset.name,
                    tags: asset.tags,
                    type: asset.type,
                    visibility: asset.visibility,
                    visibleTo: asset.visibleTo
                }]);
            }
        } else {
            if (asset.action !== 'remove' && (
                    String(asset.visibility) === '1' || 
                    (String(asset.visibility) === '2' && asset.visibleTo.indexOf(userId) >= 0)
                )) {
                    

                setAssetsList(s => {
                    let index = s.map(i => i.id).indexOf(asset.id);
                    if (index < 0) {
                        return [...s, {
                            id: asset.id,
                            name: asset.name,
                            tags: asset.tags,
                            type: asset.type,
                            visibility: asset.visibility,
                            visibleTo: asset.visibleTo
                        }]
                    } else {
                        return s.map(a => a.id !== asset.id ? a : {
                            id: asset.id,
                            name: asset.name,
                            tags: asset.tags,
                            type: asset.type,
                            visibility: asset.visibility,
                            visibleTo: asset.visibleTo
                        });
                    }
                });
            } else {
                setAssetsList(s => s.filter(a => a.id !== asset.id));
            }
        }
    },[assetUpdate, userId]);



    if (showForm) {
        return <Container>
            <Row>
                <Section><T value="assets.name"/></Section>
                <Section><T value="assets.tags"/></Section>
            </Row>
            <Row>
                <Field onChange={(e) => {handleNameChange(e.target.value)}} value={formName} />
                <Field onChange={(e) => {setFormTags(e.target.value)}} value={formTags} />
            </Row>
            <Row>
                <Section><T value="assets.type"/></Section>
                <Section><T value="assets.visibility"/></Section>
            </Row>
            <Row>
                <FieldSelect onChange={(e) => {handleChangeType(e.target.value)}} value={formType}>
                    <option value="0">{Translate("assets.type_0")}</option>
                    <option value="1">{Translate("assets.type_1")}</option>
                    {/*<option value="2">{Translate("assets.type_2")}</option>*/}
                </FieldSelect>
                <FieldSelect onChange={(e) => {handleChangeVisibility(e.target.value)}} value={formVisibility}>
                    <option value="0">{Translate("assets.visibility_0")}</option>
                    <option value="1">{Translate("assets.visibility_1")}</option>
                    <option value="2">{Translate("assets.visibility_2")}</option>
                </FieldSelect>
            </Row>
            {String(formVisibility) === "2" ? <>
                <Section><T value="assets.visibleTo"/></Section>
                <MultiPlayerSelector value={formVisibleTo} onChange={(v) => {handleChangeVisibleTo(v)}} />
            </> : null}
            {!formId ? 
                <Alert><T value="assets.afterinsert" /></Alert> 
            : 
                <ActionButtonWrapper>
                    { canChangeContent ? 
                        <ActionButton color="#6af" onClick={() => handleOpenContent()}><T value="assets.openContent"/></ActionButton>
                    :
                        <ActionButton color="#f6f" onClick={() => handleSubmitAsset(true)}><T value="assets.saveAndContinue"/></ActionButton>
                    }
                </ActionButtonWrapper> }
            {!isRemoving ? <ActionButtonWrapper>
                {!formId ? 
                    <ActionButton color="#0c0" onClick={() => handleSubmitAsset()}><T value="add"/></ActionButton>
                : <>
                    <ActionButton color="#06f" onClick={() => handleSubmitAsset()}><T value="save"/></ActionButton>
                    <ActionButton color="#f90" onClick={() => handleAskToRemove()}><T value={"delete"}/></ActionButton> 
                </>}
                <ActionButton color="#f33" onClick={handleCancelForm}><T value="cancel"/></ActionButton>
            </ActionButtonWrapper> : <ActionButtonWrapper>
                <ConfirmMessage><T value="assets.confirmRemove" /></ConfirmMessage>
                <ActionButton color="#0C0" onClick={handleCancelRemove}><T value={"no"}/></ActionButton>
                <ActionButton color="#f33" onClick={handleRemoveAsset}><T value="yes"/></ActionButton>
            </ActionButtonWrapper>}

        </Container>
    }

    return <Container>
        <Section><T value="assets.filtertag"/></Section>
        <Field className='solo' onChange={(e) => {updateFilterValue(e.target.value)}} value={filterValue} />
        <Section><T value="assets.title"/></Section>
        <AssetsList>
            {!assetsList || assetsList.length < 1 ? <NoAssets>
                <T value={isOwner ? "assets.noAssetsGM" : "assets.noAssets"} />
            </NoAssets> : assetsList.map(asset => <AssetItem key={asset.id} onClick={() => {handleOpenAsset(asset)}}>
                <AssetItemIcon className={`type${asset.type}`} />
                <AssetsItemName>{asset.name}</AssetsItemName>
                <AssetItemIcon className={`visibility${asset.visibility}`} />
            </AssetItem>)}
        </AssetsList>
        {isOwner ? <ActionButtonWrapper>
            <ActionButton color="#0C0" onClick={handleAddNewAsset}><T value="assets.newAsset"/></ActionButton>
        </ActionButtonWrapper> : null}
    </Container>
};